<template>
  <div class="hero-with-video md:px-6 md:grid md:grid-cols-2 md:gap-24 md:items-center">
    <div class="mb-6 md:mb-0">
      <KVideo
        v-if="content.video.videoUrl"
        :transcript="content.video.alt"
        :url="content.video.videoUrl"
      />
      <img
        v-else-if="content.alternativeImage"
        :src="content.alternativeImage.source"
        :alt="content.alternativeImage.alt"
        class="w-full"
      >
    </div>
    <div class="text-center md:text-left px-5 md:px-0 md:py-8">
      <h1 class="mb-2 text-sm text-gray-darkest" data-testid="heading-one">{{ content.headingOne }}</h1>
      <h2 class="mb-4 md:mb-6 text-26 md:text-34 text-primary-dark" data-testid="heading-two">{{ content.headingTwo }}</h2>
      <div
        class="richtext text-sm md:text-base mb-6 md:mb-8 md:max-w-sm text-black-medium-emphasis"
        v-dompurify-html="content.description"
        data-testid="description"
      />
      <KButton class="mx-auto md:mx-0" theme="primary" :isLoading="isLoading" @click="$emit('cta:click')">
        {{ content.getStartedButtonText }}
        <template #append>
          <KIcon
            name="arrow"
            class="h-2 ml-2 fill-current"
          />
        </template>
      </KButton>
    </div>
  </div>
</template>

<script lang="ts">
import { HeroWithVideo } from '@/model'
import { defineComponent } from 'vue'
import { KButton, KIcon, KVideo } from '@/components'

export default defineComponent({
  components: { KButton, KIcon, KVideo },
  emits: ['cta:click'],
  props: {
    content: {
      type: Object as () => HeroWithVideo,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
})
</script>
